import { GoogleMap } from './google-map';

export class GoogleMapControls {
  constructor(private readonly _map: GoogleMap) {}

  public addZoomControl(): this {
    this._map.mapInstance.setOptions({
      zoomControl: true,
    });

    return this;
  }

  public addFullscreenControl(): this {
    this._map.mapInstance.setOptions({
      fullscreenControl: true,
    });

    return this;
  }

  public addStyleControl(): this {
    this._map.mapInstance.setOptions({
      mapTypeControl: true,
    });

    return this;
  }
}
